import { getOrderApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { RemoveOrderExecutorRequest } from '@/core/generated/api';

/** Выполняет снятие исполнителя оператором */
export const removeExecutorService = {
    /** Возвращает заказ в поиск и при необходимости назначает штраф */
    async remove(request: RemoveOrderExecutorRequest): Promise<void> {
        try {
            await getOrderApi()
                .apiV1OrdersRemoveExecutorByAdminPost({
                    removeOrderExecutorRequest: request,
                });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
